import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Star, Phone } from 'lucide-react';

const Hero: React.FC = () => {
  return (
    <section className="relative min-h-screen flex items-center pt-20 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="/assets/img/chnjbg1.jpg"
          alt="Spotless Modern Kitchen"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/92 to-white/20"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 py-12">
        <div className="max-w-2xl">
          <div className="inline-flex items-center space-x-2 bg-brand-blue/10 text-brand-blue px-4 py-2 rounded-full mb-6">
            <Star className="w-4 h-4 fill-current" />
            <span className="text-xs font-bold uppercase tracking-wider">Top Rated in Hudson County</span>
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-brand-navy leading-tight mb-6">
            Professional Home Cleaning in{' '}
            <span className="text-brand-blue">Jersey City & Hoboken</span>
          </h1>

          <p className="text-lg md:text-xl text-brand-navy/80 mb-8 leading-relaxed max-w-xl">
            American Owned & Operated. Reliable, Trusted, Five-Star Rated Cleaning Services for your modern lifestyle.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-10">
            <Link
              to="/contact"
              className="bg-brand-red text-white px-8 py-4 rounded-full text-lg font-bold shadow-xl hover:bg-red-700 transition-all transform hover:scale-105 text-center"
            >
              Request a Free Quote
            </Link>
            <Link
              to="/services"
              className="bg-white text-brand-navy border-2 border-brand-navy/10 px-8 py-4 rounded-full text-lg font-bold hover:bg-gray-50 transition-all text-center shadow"
            >
              View Services
            </Link>
          </div>

          {/* Trust badges */}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 pt-8 border-t border-brand-navy/10">
            <div className="flex items-center space-x-3">
              <CheckCircle className="w-5 h-5 text-brand-blue shrink-0" />
              <span className="text-sm font-semibold text-brand-navy">Fully Insured & Bonded</span>
            </div>
            <div className="flex items-center space-x-3">
              <CheckCircle className="w-5 h-5 text-brand-blue shrink-0" />
              <span className="text-sm font-semibold text-brand-navy">Background Checked</span>
            </div>
            <div className="flex items-center space-x-3">
              <CheckCircle className="w-5 h-5 text-brand-blue shrink-0" />
              <span className="text-sm font-semibold text-brand-navy">Eco-Friendly Options</span>
            </div>
          </div>

          {/* Mobile click-to-call — always visible on mobile, below badges */}
          <div className="mt-6 lg:hidden">
            <a
              href="tel:2018700452"
              className="flex items-center justify-center space-x-3 bg-brand-navy text-white py-4 rounded-2xl font-bold text-lg w-full shadow-lg"
            >
              <Phone className="w-5 h-5" />
              <span>Call (201) 870-0452</span>
            </a>
          </div>
        </div>
      </div>

      {/* Subtle Patriotic Accent */}
      <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-brand-blue via-white to-brand-red opacity-50"></div>
    </section>
  );
};

export default Hero;
